import { ATSPrincipalAppTestIds } from 'data-testids/ATS';
import { HiringRequestsLandingPage } from 'features/Connect/features/ConnectATSIntegration/HiringRequestsLandingPage';
import auth from 'utils/auth';
import { PageContainer } from '../Navbar/styles';

export const PrincipalHiringRequests = () => {
  const user = auth.getUser();

  if (user) {
    return (
      <PageContainer data-testid={ATSPrincipalAppTestIds.HIRING_REQUESTS_LIST}>
        <HiringRequestsLandingPage />
      </PageContainer>
    );
  }

  return <></>;
};
